import { ReactNode } from 'react'
import styles from '../ModalFooter/modalFooter.module.scss'

interface Props {
  dataTestId?: string
  title?: ReactNode
  content?: string | ReactNode | undefined
  className?: string
}

const OrderStatusMessage = ({
  title,
  dataTestId,
  content,
  className
}: Props) => {
  return (
    <div
      data-testid={dataTestId}
      className={`${styles.bottomContent} ${className}`}
    >
      <div className={`${styles.bottomText}`}>
        <div className={`${styles.bottomTextTitle}`}>{title}</div>
        <div className={`${styles.bottomTextContent}`}>{content}</div>
      </div>
    </div>
  )
}

export default OrderStatusMessage
